import React, { forwardRef } from 'react';
import { FieldError } from 'react-hook-form/dist/types';
import classNames from 'classnames';

import './style.css';

type Option = {
  /** Option value. */
  value: string | number;

  /** Option label. */
  label: string;

  /** Option disabled state. */
  disabled?: boolean;
};

interface BaseSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
  invalid?: FieldError | unknown;
  onChangeForController?: (value: string) => void;
}

/** Base select component. */
const BaseSelect = forwardRef<HTMLSelectElement, BaseSelectProps>((props, ref) => {
  const { options, invalid, value, onChangeForController, className, ...rest } = props;

  const isPlaceholderSelected = options.length > 0 && options[0].value === value && options[0].disabled;

  const selectClassName = classNames('form-control', 'has-placeholder', className, {
    invalid,
    selectPlaceholder: isPlaceholderSelected,
  });

  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    onChangeForController?.(event.target.value);

    props.onChange?.(event);
  };

  return (
    <div className="form-group">
      <select {...rest} ref={ref} value={value} className={selectClassName} onChange={onSelectChange}>
        {options.map((option, index) => (
          <option
            className={classNames('option', {
              optionDisable: option.disabled,
            })}
            key={index}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
});

BaseSelect.displayName = 'BaseSelect';

export default BaseSelect;
